import {
  type AroundATimeState,
  CalendarWithDateTimeFields,
  type TimeRangeSelectionMode,
} from '@chronosphereio/chrono-ui';
import { isTimeRangeInputValueAbsolute, TimeRangeInputValue } from '@chronosphereio/core';
import { useUserTimeFormat } from '@/plugin-system/runtime/useUserTimeFormat';
import { absoluteTimeRangeDatesHaveCorrectOrder } from '../utils';

const noop = () => {};
const DEFAULT_AROUND_A_TIME: AroundATimeState = {
  center: '',
  duration: '',
  setCenter: noop,
  setDuration: noop,
};

export interface TimeRangeTextFieldsProps {
  initialTimeRange: TimeRangeInputValue;
  onTimeRangeChange: (timeRange: TimeRangeInputValue) => void;
  timeZone?: string;
  minDate?: Date;
  maxDate?: Date;
  aroundATime?: AroundATimeState;
  timeRangeSelectionMode?: TimeRangeSelectionMode;
  setTimeRangeSelectionMode?: (mode: TimeRangeSelectionMode) => void;
}

export const TimeRangeTextFields = ({
  initialTimeRange,
  onTimeRangeChange,
  timeZone,
  minDate,
  maxDate,
  aroundATime = DEFAULT_AROUND_A_TIME,
  timeRangeSelectionMode,
  setTimeRangeSelectionMode,
}: TimeRangeTextFieldsProps) => {
  const timeFormat = useUserTimeFormat();

  const onApplyFlexibleTimeRange = (timeRange: TimeRangeInputValue) => {
    if (isTimeRangeInputValueAbsolute(timeRange) && !absoluteTimeRangeDatesHaveCorrectOrder(timeRange)) {
      // TODO: Currently we ignore selections with dates in the wrong order. Is that correct?
      return;
    }
    onTimeRangeChange(timeRange);
  };

  return (
    <CalendarWithDateTimeFields
      inputMode="flexible"
      onApply={onApplyFlexibleTimeRange}
      initialTimeRange={initialTimeRange}
      aroundATime={aroundATime}
      timeRangeSelectionMode={timeRangeSelectionMode}
      setTimeRangeSelectionMode={setTimeRangeSelectionMode}
      timeZone={timeZone}
      minDate={minDate}
      maxDate={maxDate}
      timeFormat={timeFormat}
    />
  );
};
